var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.externalId !== null && _vm.externalId !== undefined)?_c('InnerCardInfo',{ref:"inner",attrs:{"label":_vm.label,"data":[
    {
      name: _vm.label,
      value: _vm.externalId || '-',
    },
  ],"editReady":_vm.editReady}},[_c('template',{slot:"edit_block"},[_vm._t("default")],2)],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }